var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word_box",attrs:{"id":_vm.content.key}},[_c('audio',{attrs:{"src":"","id":"audio_word"}}),_c('span',{staticClass:"word_title",style:({
      marginTop: _vm.content.textStyle.marginTop + 'rem' || '',
    })},[_vm._v(_vm._s(_vm.content.text))]),_vm._l((_vm.content.content),function(item){return _c('div',{key:item.key},_vm._l((item.content),function(items){return _c('div',{key:items.key,staticClass:"word_list"},[_c('div',{staticClass:"word_list_left"},[_c('div',{staticClass:"word_list_left_top"},[_c('span',{style:({
          fontFamily: items.textStyle.fontFamily || '',
          fontSize: items.textStyle.fontSize + 'rem' || '',
          lineHeight: items.textStyle.lineHeight + 'rem' || '',
          fontWeight: items.textStyle.fontWeight || '',
          textDecoration:
            items.textStyle.underline === 1 ? 'underline' : '',
          fontStyle: items.textStyle.fontItalic === 1 ? 'italic' : '',
          textAlign: items.textStyle,
          color:items.ispop ?'#0482EC': items.textStyle.color,
        })},[_vm._v("\n          "+_vm._s(items.ispop ?'':items.text)),(items.ispop)?_c('popover',{attrs:{"content":items}}):_vm._e()],1),_c('span',{style:({
            fontFamily: item.word_mark_style.fontFamily || '',
            fontSize: item.word_mark_style.fontSize + 'rem' || '',
            lineHeight: item.word_mark_style.lineHeight + 'rem' || '',
            fontWeight: item.word_mark_style.fontWeight || '',
            textDecoration:
              item.word_mark_style.underline === 1 ? 'underline' : '',
            fontStyle: item.word_mark_style.fontItalic === 1 ? 'italic' : '',
            textAlign: item.word_mark_style.textAlign || '',
            color: item.word_mark_style.color || '',
            backgroundColor: item.word_mark_style.backgroundColor || '',
          })},[_vm._v(_vm._s(item.word_mark))])]),_c('div',{staticClass:"word_list_left_bottom"},_vm._l((item.word_translate),function(ite){return _c('span',{key:ite.key,ref:"",refInFor:true,style:({
            color:ite.textStyle.color ||'',
            fontFamily: ite.textStyle.fontFamily || '',
            fontSize: ite.textStyle.fontSize + 'rem' || '',
            lineHeight: ite.textStyle.lineHeight + 'rem' || '',
            fontWeight: ite.textStyle.fontWeight || '',
            textDecoration:
              ite.textStyle.underline === 1 ? 'underline' : '',
            fontStyle: ite.textStyle.fontItalic === 1 ? 'italic' : '',
          })},[_vm._v(_vm._s(ite.text))])}),0)]),_c('div',{staticClass:"word_list_right"},[_c('img',{attrs:{"src":!item.isPlay
            ? require('@/assets/images/books/book2/play_default.png')
            : require('@/assets/images/books/book2/play_process.png'),"alt":""},on:{"click":function($event){return _vm.audioPlayClick(item)}}})])])}),0)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }